/* Studio Fedde: eigen kaart voor de studio-overzichtspagina.
   Leest de studio's uit de kaarten op de pagina (breedte- en lengtegraad),
   tekent ze op een minimalistische kaart in huisstijl (MapLibre + OpenFreeMap,
   geen cookies, geen sleutel) en beweegt mee als de bezoeker een postcode
   zoekt of zijn locatie deelt. */
(function () {
  'use strict';

  var TEXT = {
    nl: { close: 'Sluiten', zoomIn: 'Inzoomen', zoomOut: 'Uitzoomen', touch: 'Gebruik twee vingers om de kaart te verplaatsen', scroll: 'Gebruik Ctrl + scrollen om de kaart te zoomen', scrollMac: 'Gebruik ⌘ + scrollen om de kaart te zoomen', you: 'Jouw locatie' },
    en: { close: 'Close', zoomIn: 'Zoom in', zoomOut: 'Zoom out', touch: 'Use two fingers to move the map', scroll: 'Use Ctrl + scroll to zoom the map', scrollMac: 'Use ⌘ + scroll to zoom the map', you: 'Your location' },
    de: { close: 'Schließen', zoomIn: 'Vergrößern', zoomOut: 'Verkleinern', touch: 'Verschiebe die Karte mit zwei Fingern', scroll: 'Mit Strg + Scrollen zoomst du die Karte', scrollMac: 'Mit ⌘ + Scrollen zoomst du die Karte', you: 'Dein Standort' },
    fr: { close: 'Fermer', zoomIn: 'Zoom avant', zoomOut: 'Zoom arrière', touch: 'Utilisez deux doigts pour déplacer la carte', scroll: 'Utilisez Ctrl + molette pour zoomer', scrollMac: 'Utilisez ⌘ + molette pour zoomer', you: 'Votre position' },
    es: { close: 'Cerrar', zoomIn: 'Acercar', zoomOut: 'Alejar', touch: 'Usa dos dedos para mover el mapa', scroll: 'Usa Ctrl + rueda para hacer zoom', scrollMac: 'Usa ⌘ + rueda para hacer zoom', you: 'Tu ubicación' }
  };
  var lang = (document.documentElement.lang || 'nl').slice(0, 2).toLowerCase();
  var T = TEXT[lang] || TEXT.nl;

  var SLASH = '<svg viewBox="0 0 10 18" width="9" height="16" aria-hidden="true" focusable="false"><line x1="2" y1="17" x2="8" y2="1" stroke="#D0CDBC" stroke-width="1.9" stroke-linecap="butt"/></svg>';

  function loadCss(href) {
    if (document.querySelector('link[data-sf-maplibre]')) return;
    var l = document.createElement('link');
    l.rel = 'stylesheet'; l.href = href; l.setAttribute('data-sf-maplibre', '');
    document.head.appendChild(l);
  }

  function loadJs(src) {
    return new Promise(function (resolve, reject) {
      if (window.maplibregl) return resolve();
      var s = document.createElement('script');
      s.src = src; s.async = true;
      s.onload = resolve; s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  function el(tag, cls, html) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html != null) e.innerHTML = html;
    return e;
  }

  function esc(t) {
    return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function init(box) {
    var root = box.closest('[data-sf-studios]') || document;
    var canvas = box.querySelector('[data-sf-map-canvas]');
    var isMobile = function () { return window.matchMedia && window.matchMedia('(max-width: 749px)').matches; };
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var studios = [];
    root.querySelectorAll('.sf-sto-card').forEach(function (card) {
      var lat = parseFloat(card.getAttribute('data-lat'));
      var lng = parseFloat(card.getAttribute('data-lng'));
      if (isNaN(lat) || isNaN(lng)) return;
      var soonEl = card.querySelector('.sf-sto-card__soon');
      studios.push({
        card: card, lat: lat, lng: lng,
        name: card.getAttribute('data-name') || '',
        url: card.getAttribute('data-url') || '',
        route: card.getAttribute('data-route') || '',
        street: (card.querySelector('.sf-sto-card__meta') || {}).textContent || '',
        soon: card.hasAttribute('data-soon'),
        soonLabel: soonEl ? soonEl.textContent.trim() : ''
      });
    });
    if (!studios.length) { box.classList.add('is-failed'); return; }

    var cooperative = true;
    var map;
    try {
      map = new maplibregl.Map({
        container: canvas,
        style: box.getAttribute('data-style'),
        center: [5.0, 52.05],
        zoom: 7,
        minZoom: 4,
        maxZoom: 16,
        attributionControl: false,
        dragRotate: false,
        pitchWithRotate: false,
        cooperativeGestures: cooperative,
        fadeDuration: reduce ? 0 : 200,
        locale: {
          'Popup.Close': T.close,
          'NavigationControl.ZoomIn': T.zoomIn,
          'NavigationControl.ZoomOut': T.zoomOut,
          'CooperativeGesturesHandler.WindowsHelpText': T.scroll,
          'CooperativeGesturesHandler.MacHelpText': T.scrollMac,
          'CooperativeGesturesHandler.MobileHelpText': T.touch
        }
      });
    } catch (e) {
      box.classList.add('is-failed');
      return;
    }
    box.sfMap = map;
    map.touchZoomRotate.disableRotation();
    map.addControl(new maplibregl.NavigationControl({ showCompass: false, visualizePitch: false }), 'bottom-left');
    map.addControl(new maplibregl.AttributionControl({ compact: true }), 'bottom-right');
    map.on('error', function (ev) {
      if (ev && ev.error && /Failed to fetch|NetworkError|AJAXError/i.test(String(ev.error.message || ev.error))) {
        if (!map.loaded()) box.classList.add('is-failed');
      }
    });

    /* Ruimte die de zwevende zoekbalk (alleen desktop) onderaan inneemt. */
    function padding() {
      var hero = box.closest('.sf-sto-hero');
      if (hero) {
        /* Header met kaart: houd de pinnen uit de buurt van de tekstkaart die op desktop over de kaart ligt. */
        if (isMobile()) return { top: 48, bottom: 56, left: 124, right: 104 };
        var copy = hero.querySelector('.sf-ch-copy');
        var left = copy ? Math.max(64, copy.getBoundingClientRect().right - box.getBoundingClientRect().left + 56) : 64;
        return { top: 72, bottom: 72, left: left, right: 72 };
      }
      return isMobile()
        ? { top: 48, bottom: 84, left: 116, right: 116 }
        : { top: 56, bottom: 108, left: 64, right: 64 };
    }

    function fitAll(animate) {
      var b = new maplibregl.LngLatBounds();
      studios.forEach(function (s) { b.extend([s.lng, s.lat]); });
      map.fitBounds(b, { padding: padding(), maxZoom: 9.6, duration: (animate && !reduce) ? 800 : 0 });
    }

    var popup = null;
    function closePopup() { if (popup) { popup.remove(); popup = null; } }

    function openPopup(s) {
      closePopup();
      var html = '<div class="sf-map-card">'
        + '<div class="sf-map-card__title">' + esc(s.name) + '</div>'
        + (s.street ? '<div class="sf-map-card__street">' + esc(s.street) + '</div>' : '')
        + (s.soon && s.soonLabel ? '<div class="sf-map-card__soon">' + esc(s.soonLabel) + '</div>' : '')
        + '<div class="sf-map-card__links">'
        + (s.route ? '<a class="sf-link-arrow" href="' + esc(s.route) + '" target="_blank" rel="noopener">' + esc(box.getAttribute('data-route-label') || 'Route') + '</a>' : '')
        + (s.url ? '<a class="sf-link-arrow" href="' + esc(s.url) + '">' + esc(box.getAttribute('data-detail-label') || '') + '</a>' : '')
        + '</div></div>';
      popup = new maplibregl.Popup({ offset: 22, closeButton: true, closeOnMove: false, focusAfterOpen: false, maxWidth: '280px', className: 'sf-map-popup' })
        .setLngLat([s.lng, s.lat]).setHTML(html).addTo(map);
    }

    /* Labels van de westelijke studio's links van de pin, de rest rechts: zo botsen ze minder. */
    var lngs = studios.map(function (x) { return x.lng; }).sort(function (a, b) { return a - b; });
    var medianLng = lngs[Math.floor((lngs.length - 1) / 2)];

    var markers = [];
    studios.forEach(function (s) {
      var btn = el('button', 'sf-map-pin' + (s.soon ? ' is-soon' : ''), SLASH);
      btn.type = 'button';
      btn.setAttribute('aria-label', s.name);
      var label = el('span', 'sf-map-pin__label');
      label.textContent = s.name;
      var wrap = el('div', 'sf-map-pinwrap' + (s.lng < medianLng - 0.001 ? ' is-left' : ''));
      wrap.appendChild(btn); wrap.appendChild(label);
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        openPopup(s);
      });
      var m = new maplibregl.Marker({ element: wrap, anchor: 'center' }).setLngLat([s.lng, s.lat]).addTo(map);
      markers.push({ s: s, marker: m, el: wrap });
    });

    var here = null;
    function showHere(origin) {
      if (!here) {
        var d = el('div', 'sf-map-here');
        d.setAttribute('role', 'img');
        d.setAttribute('aria-label', T.you);
        d.title = T.you;
        here = new maplibregl.Marker({ element: d, anchor: 'center' }).setLngLat([origin.lng, origin.lat]).addTo(map);
      } else {
        here.setLngLat([origin.lng, origin.lat]);
      }
    }

    function nearestZoom(distKm) {
      return distKm < 3 ? 13 : distKm < 8 ? 12 : distKm < 20 ? 11 : distKm < 45 ? 10 : distKm < 90 ? 9 : 8;
    }

    /* Na een zoekactie: toon de gezochte plek en de dichtstbijzijnde studio samen. */
    document.addEventListener('sf-studios:sorted', function (ev) {
      var d = ev.detail || {};
      if (!d.origin || !d.nearest) return;
      closePopup();
      showHere(d.origin);
      var b = new maplibregl.LngLatBounds();
      b.extend([d.origin.lng, d.origin.lat]);
      b.extend([d.nearest.lng, d.nearest.lat]);
      var maxZ = nearestZoom(d.nearest.km || 0);
      map.fitBounds(b, { padding: padding(), maxZoom: maxZ, duration: reduce ? 0 : 900 });
      var nearestStudio = null;
      markers.forEach(function (m) {
        var isNearest = m.s.lat === d.nearest.lat && m.s.lng === d.nearest.lng;
        if (isNearest) nearestStudio = m.s;
        m.el.classList.toggle('is-nearest', isNearest);
      });
      /* Na een zoekactie of 'Mijn locatie' opent het infokaartje van de dichtstbijzijnde studio.
         Alleen bij 'auto' (locatie was al toegestaan, geen klik) blijft de kaart rustig. */
      if (d.source !== 'auto' && nearestStudio) {
        var opened = false;
        var show = function () { if (!opened) { opened = true; openPopup(nearestStudio); } };
        map.once('moveend', show);
        setTimeout(show, reduce ? 50 : 1400);
      }
    });

    map.on('click', closePopup);

    var ready = function () { fitAll(false); box.classList.add('is-ready'); };
    if (map.loaded()) ready(); else map.once('load', ready);
    window.addEventListener('resize', function () {
      if (!here) fitAll(false);
    });
  }

  function boot() {
    var boxes = document.querySelectorAll('[data-sf-map]');
    boxes.forEach(function (box) {
      var started = false;
      function start() {
        if (started) return;
        started = true;
        loadCss(box.getAttribute('data-css'));
        loadJs(box.getAttribute('data-js')).then(function () { init(box); }).catch(function () { box.classList.add('is-failed'); });
      }
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) { io.disconnect(); start(); }
        }, { rootMargin: '400px 0px' });
        io.observe(box);
      } else {
        start();
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
